import { graphql, useStaticQuery } from '@amazeelabs/gatsby-plugin-operations';
import { BlogPaginationQuery } from '@custom/schema';

export const useBlogPaginationQuery = () =>
  useStaticQuery(graphql(BlogPaginationQuery));
